export default "__VITE_ASSET__8d230b53__"